import { defineStore } from 'pinia';
import { createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type { IGameInfo, IGameInfoStrapiResponse } from '~/types/games';

export const useStoreGamesStrapi = defineStore('gamesStrapi', {
  state: () => ({
    games: [] as IGameInfo[],
    requestPromise: null as Promise<IGameInfoStrapiResponse> | null,
  }),

  actions: {
    async loadGamesInfo() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'head',
          'head.alternates',
          'specs',
          'breadcrumbsItem',
          'breadcrumbsItem.itemImage',
          'mirrorHead',
          'mirrorBody',
        ]);

        // @TODO: refactor after game will migrate to strapi
        this.requestPromise = strapi()
          .get('game-infos', populateString, 'en')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        this.games = response.data;

        return true;
      } else {
        return false;
      }
    },
  },
});
